export const TABS_CONSTANT = {
  OVERVIEW: 'OVERVIEW',
  CURRICULUM: 'CURRICULUM',
  CASE_STUDIES: 'CASE STUDIES',
  FACULTIES: 'FACULTIES',
  CERTIFICATION: 'CERTIFICATION',
  SUCCESS_STORIES: 'SUCCESS STORIES',
  COURSE_FEE: 'COURSE FEE',
  APPLICATION_PROCESS: 'APPLICATION PROCESS',
  FAQs: 'FAQs'
};

export const ENROLLMENT_END_TYPES = {
  MORE_THAN_3: {
    background: '#F7F9FB',
    color: '#3C4852',
    icon: 'certificationCourses/enrolled-icon.svg'
  },
  LESS_THAN_3: {
    background: '#FEF5F5',
    color: '#EB5757',
    icon: 'certificationCourses/enrolled-icon-red.svg'
  },
  CLOSED: {
    background: '#F7F9FB',
    color: '#7A8B94',
    icon: null
  }
};

export const CONTAIN_PADDING = [
  TABS_CONSTANT.FACULTIES,
  TABS_CONSTANT.SUCCESS_STORIES
];

export const PROGRAM_LANDING_PAGE = 'Program Landing page';

export const EVENT_NAME_MAPPING = {
  DOWNLOAD_BROCHURE: 'brochure_downloaded',
  I_AM_INTERESTED: 'interest_submitted'
};
